<div class="profile-picture">
    <img *ngIf="user.photoURL" class="photo" [src]="user.photoURL">
    <div *ngIf="!user.photoURL" class="no-photo">
        <label class="initials">{{user.displayName.substring(0, 1)}}</label>
    </div>
</div>
